<template>
    <div class="costDirectMaterials-box">
        <HeaderNav
            header-title="直接材料成本"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="warpper">
            <div class="overstock-fund">
                <div
                    class="item"
                    v-for="item in costDirectData"
                    :key="item.type_code"
                    :class="`color${item.sort_num}`"
                >
                    <div class="item-box">
                        <div class="procuct-company">
                            <h4 v-text="item.type_name"></h4><span class="company">单位:元/方</span>
                        </div>
                        <div class="end-term">
                            <span class="num">{{ item.total|toFixedNumber }}</span>
                            <span class="tag">本年累计</span>
                        </div>
                        <div class="split-line"></div>
                        <div class="ratio">
                            <div class="ratio-item" :class="[{'ratio-item-up':item.settlementprice>0}, {'ratio-item-down':item.settlementprice<0}]">
                                <div class="num">
                                    <span>{{ item.settlementprice|absNum|toFixedNumber }}</span>
                                </div>
                                <div class="text">
                                    <span>本月</span>
                                    <!-- <span
                                        class="iconfont iconshangsheng"
                                        v-if="item.settlementprice>0"
                                    ></span>
                                    <span
                                        class="iconfont iconxiajiang"
                                        v-if="item.settlementprice<0"
                                    ></span> -->
                                </div>
                            </div>
                            <div class="ratio-item" :class="[{'ratio-item-up':item.chain>0}, {'ratio-item-down':item.chain<0}]">
                                <div class="num">
                                    <span>{{ item.chain|absNum|toFixedNumber }}</span>
                                </div>
                                <div class="text">
                                    <span>环比</span>
                                    <span
                                        class="iconfont iconshangsheng"
                                        v-if="item.chain>0"
                                    ></span>
                                    <span
                                        class="iconfont iconxiajiang"
                                        v-if="item.chain<0"
                                    ></span>
                                </div>
                            </div>
                            <div
                                class="ratio-item"
                                :class="[{'ratio-item-up':item.year>0}, {'ratio-item-down':item.year<0}]"
                            >
                                <div class="num">
                                    <span>{{ item.year|absNum|toFixedNumber }}</span>
                                </div>
                                <div class="text">
                                    <span>同比</span>
                                    <span
                                        class="iconfont iconshangsheng"
                                        v-if="item.year>0"
                                    ></span>
                                    <span
                                        class="iconfont iconxiajiang"
                                        v-if="item.year<0"
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Dialog } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            orgId: '', // 当前组织ID
            year: '', // 年
            month: '', // 月
            costDirectData: [], // 库存data
        };
    },
    methods: {
        // 获取直接成本信息
        getCostDirect() {
            this.$axios
                .get('/interfaceApi/report/CostsManager/get_costs_direct/' + this.year + '/' + this.month + '/' + this.orgId)
                .then(res => {
                    if (res) {
                        this.costDirectData = res;
                    }
                }).catch(error => {
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
    },
    created() {
        this.orgId = this.$route.params.orgId;
        this.year = this.$route.params.year;
        this.month = this.$route.params.month;
        localStorage.setItem('objTimeYear', this.$route.params.year);
        localStorage.setItem('objTimeMonth', this.$route.params.month);
        this.getCostDirect();
    },
};
</script>

<style lang="stylus" scoped>
.costDirectMaterials-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .warpper
        height 100%
        overflow-y auto
        .header
            width 100%
            height 30rpx
            background #F0F0F0
            font-size 12rpx
            text-align center
            line-height 30rpx
            .iconrili
                font-size 14rpx
                margin-right 6rpx
        .chart-title
            padding 15rpx 3% 10rpx
            font-size 16rpx
            position relative
            .subtitle
                float right
                color #979EA7
                font-size 10rpx
                padding-top 4rpx
        .split
            width 100%
            height 15rpx
            background #F0F0F0
        // table
        //     width 100%
        //     border-spacing 0px
        //     border-collapse collapse
        //     margin-top 15rpx
        //     td
        //         border 2.5rpx solid #fff
        //         border-collapse collapse
        //         height 45rpx
        //         text-align center
        //         width 40rpx
        //         font-size 14rpx
        //     .row-item
        //         td
        //             background rgba(240,240,240,0.5)
        //         .row-item-pink
        //             background rgba(235,101,111,0.1)
        //             color #EB656F
        //     .t-header
        //         td
        //             background rgba(85,136,241,0.1)
        //             color #5588F1
        //             font-size 14rpx
        //             padding 4rpx 0
        //             span
        //                 border-top 1px solid #5588F1
        //                 font-size 10rpx
        //                 padding-top 4rpx
        //             div
        //                 margin-bottom 4rpx
        .overstock-fund
            width 100%
            .item
                float left
                width 50%
                padding 8rpx
                .item-box
                    height 130rpx
                    width 100%
                    border 1px solid #F0F0F0
                    box-shadow 1px 2px 6px 0px #F0F0F0
                    border-radius 4rpx
                h4
                    font-size 14rpx
                    padding 8rpx
                .procuct-company
                    display flex
                    justify-content space-between
                    align-items center
                    .company
                        font-size 12rpx
                        margin-right 10rpx
                        color #999
                .end-term
                    padding 0 8rpx
                    overflow hidden
                    .num
                        float left
                        font-size 18rpx
                        color #5588F1
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    .tag
                        float left
                        width 58rpx
                        height 20rpx
                        color #5588F1
                        font-size 10rpx
                        text-align center
                        line-height 21rpx
                        background url(./images/cost_icon1.png) no-repeat
                        background-size 100% 100%
                        text-align center
                        padding-left 3rpx
                .split-line
                    border-bottom 1px dashed #F0F0F0
                    margin 10rpx 0
                .ratio
                    display flex
                    .ratio-item
                        flex 0 0 30%
                        margin-left 2%
                        background rgba(235,101,111,0.06)
                        text-align center
                        .num
                            font-size 12rpx
                            margin 3rpx 0
                            .iconfont
                                font-size 12rpx
                        .text
                            font-size 10rpx
                            color #979EA7
                            .iconfont
                                font-size 12rpx
                        &.ratio-item-up
                            background rgba(235,101,111,0.06)
                            .text
                                .iconfont
                                    color #EB656F
                        &.ratio-item-down
                            background rgba(85,136,241,0.06)
                            .text
                                .iconfont
                                    color #18A001
                &.color1
                    .end-term
                        .num
                            color #5588F1
                        .tag
                            color #5588F1
                            background url(./images/cost_icon1.png) no-repeat
                            background-size 100% 100%
                &.color2
                    .end-term
                        .num
                            color #FA8436
                        .tag
                            color #FA8436
                            background url(./images/cost_icon2.png) no-repeat
                            background-size 100% 100%
                &.color3
                    .end-term
                        .num
                            color #8B6BEE
                        .tag
                            color #8B6BEE
                            background url(./images/cost_icon3.png) no-repeat
                            background-size 100% 100%
                &.color4
                    .end-term
                        .num
                            color #21BDCC
                        .tag
                            color #21BDCC
                            background url(./images/cost_icon4.png) no-repeat
                            background-size 100% 100%
                &.color5
                    .end-term
                        .num
                            color #F1B000
                        .tag
                            color #F1B000
                            background url(./images/cost_icon5.png) no-repeat
                            background-size 100% 100%
                &.color6
                    .end-term
                        .num
                            color #EB656F
                        .tag
                            color #EB656F
                            background url(./images/cost_icon6.png) no-repeat
                            background-size 100% 100%
</style>